// extracted by mini-css-extract-plugin
export default {"base":"Questionnaire_base__lBumj","textBox":"Questionnaire_textBox__1jdE+","deleteIcon":"Questionnaire_deleteIcon__kpEvr"};